import { useAuth } from '../auth/AuthContext.jsx';

/**
 * Anchor-style download trigger for CSV endpoints. Uses the same
 * ?token= fallback the SSE / attachment endpoints use, so the browser
 * download dialog gets authenticated. Hidden when the user lacks can_export.
 */
export default function ExportButton({ path, label = 'Export CSV', className = 'btn-ghost text-sm' }) {
  const { hasPermission } = useAuth();
  if (!hasPermission('can_export')) return null;
  const token = localStorage.getItem('utsc_token');
  const href = `/api${path}${path.includes('?') ? '&' : '?'}token=${encodeURIComponent(token || '')}`;
  return (
    <a href={href} className={className} download>
      ⬇ {label}
    </a>
  );
}
